export function shortenDesc(desc) {
  if (!desc) return '';
  if (desc.length > 128) {
    return desc.substring(0, 128) + '...';
  }
  else return desc
}